export const campOptions = {
  GADGETS: 'GADGETS',
  TSHIRTSIZE: 'TSHIRTSIZE',
  SHORTSIZE: 'SHORTSIZE',
  SHOESIZE: 'SHOESIZE'
}
